
import Group from 'vux/src/components/group/index.vue'
import Cell from 'vux/src/components/cell/index.vue'
import Timeline from 'vux/src/components/timeline/timeline.vue'
import TimelineItem from 'vux/src/components/timeline/timeline-item.vue'
import XButton from 'vux/src/components/x-button/index.vue'
import Flexbox from 'vux/src/components/flexbox/flexbox.vue'
import FlexboxItem from 'vux/src/components/flexbox/flexbox-item.vue'
import XTextarea from 'vux/src/components/x-textarea/index.vue'
import XInput from 'vux/src/components/x-input/index.vue'
import Datetime from 'vux/src/components/datetime/index.vue'
import dateFormat from 'vux/src/tools/date/format.js'

import Upload from '@/components/UploadImage'
import CPosition from '@/components/Position'
export default {
name: 'Order',
components: {
Cell,
Group,
Timeline,
TimelineItem,
XButton,
Flexbox,
FlexboxItem,
Upload,
XTextarea,
CPosition,
XInput,
Datetime
},
data () {
return {
ID: '',
MEMO: '',
isComplete: false,
uploadParams: {},
color: 'red',
order: {ARR_THD_DT: dateFormat(new Date(), 'YYYY-MM-DD HH:mm:ss'), IS_ARR_THD: 0},
PS_TRUCK_COUNT: 0,
orderFiles: [],
demageFiles: [],
hasOrderImg: false, // 是否已经提交提货交接单
hasDemageImg: false, // 是否已经提交破损交接单
isSubmit: false
}
},
computed: {
position () {
return this.$store.getters.getPosition
}
},
created () {
this.ID = this.$route.query.ID || ''
if (process.env.NODE_ENV != 'development' && this.$store.state.app.roleid != 0) {
this.$router.replace({
path: './th/order?ID=' + this.ID
})
return
}
this.uploadParams = {
SUBDIR: this.$config.SUBDIR.th
}
this.loadData()
this.$store.dispatch('baiduPosition')
},
methods: {
arrThdTdChange () {

},
loadData () {
let _this = this
_this.$vux.loading.show()
let url = 'TH.ashx?action=Form_Load'
this.$post(url, {
ID: this.ID
}).then(
response => {
_this.order = response
if (_this.order.STATUS == 1 && _this.order.IS_ARR_THD == 0) {
_this.order.ARR_THD_DT = dateFormat(new Date(), 'YYYY-MM-DD HH:mm')
}
_this.isComplete = _this.order.STATUS == 2
_this.color = _this.order.STATUS == 2 ? '#04BE02' : 'red'

if (_this.isComplete) {
_this.toPsd()
return
}
if (_this.isComplete) _this.MEMO = _this.order.TH_MEMO
_this.$vux.loading.hide()
_this.getOrderFiles()
}
).catch(
response => {
console.log(response, '请求失败')
}
)
},
getOrderFiles () {
let _this = this
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_order, res => {
if (res.length > 0) _this.hasOrderImg = true
_this.orderFiles = res
})
_this.$comapi.GetWebFile(_this.order.WORKNO, _this.$config.F_SRC.th_demage, res => {
if (res.length > 0) _this.hasDemageImg = true
_this.demageFiles = res
})
},
submitOrderFiles (file) {
let _this = this
_this.$comapi.SaveWebFile(this.order.WORKNO, _this.$config.F_SRC.th_order, file, function (res) {
if (res) _this.hasOrderImg = true
})
},
submitDemageFiles (file) {
let _this = this
_this.$comapi.SaveWebFile(this.order.WORKNO, _this.$config.F_SRC.th_demage, file, function (res) {
if (res) _this.hasDemageImg = true
})
},
toThd () {
let _this = this
if (this.isSubmit) return
this.isSubmit = true
let param = {
ID: _this.ID,
IS_ARR_THD: 1,
ARR_THD_DT: _this.order.ARR_THD_DT
}
_this.$post('TH.ashx?action=Update_THD', param).then(res => {
_this.$toast.success('到达提货点操作成功')
setTimeout(() => {
_this.order.IS_ARR_THD = 1
_this.isSubmit = false
}, 1000)
}).catch(res => {
setTimeout(function () {
_this.isSubmit = false
}, 3000)
})
},
toComplete () {
let _this = this




if (this.hasDemageImg && this.PS_TRUCK_COUNT <= 0) {
this.$toast.text('有破损情况下，必须录入破损票数')
return
}
if (this.isSubmit) return
this.isSubmit = true
let param = {
ID: _this.ID,
TH_MEMO: _this.MEMO,
SLAT: _this.position.lat,
SLNG: _this.position.lng,
ADDR: _this.position.addr,
PS_TRUCK_COUNT: _this.PS_TRUCK_COUNT,
ALARM_INFO: JSON.stringify({
MSG_CODE: 'TH_DONE',
BASE_ID: 21
})
}
_this.$post('TH.ashx?action=Update_Status2', param).then(res => {
_this.$toast.success('提货成功')
setTimeout(() => {
_this.$route.back()
}, 1000)
}).catch(res => {
setTimeout(function () {
_this.isSubmit = false
}, 3000)
})
},
toPsd () {
if (this.order.TRANS_INFO && this.order.TRANS_INFO.ID) {
this.$router.push('./psd?ID=' + this.order.TRANS_INFO.ID)
}
},
toAbnormal () {
this.$router.push({
path: './abnormal?TYPE=0&ID=' + this.ID
})
}
}
}



// WEBPACK FOOTER //
// ./src/pages/sctsnew/Thd.vue